// btw-front/src/constants/dealReview.js
// 딜 심사 상태 3개 — 백 `btw-back/constants/dealReview.js` 와 동기.
//
// 영업단계(constants/dealStatus.js)와 **별개 축**이다. 심사가 끝나지 않은 딜은 영업단계 배지
// 대신 심사 배지를 보여준다 — 축이 다른 값을 한 배지에 섞으면 파트너가 진행 상황을 오해한다.
//
// **반려 딜은 되살릴 수 없다** — 반려와 동시에 소프트 삭제되어 [삭제된 딜] 에도 나타난다
// (심사 이력이므로 [딜 심사 > 처리 완료] 목록에도 함께 남는다).
// 재심사 기능은 없고, 파트너는 사유를 확인한 뒤 새 딜로 다시 등록한다(PartnerDealDetail 의 반려 배너).
// 그래도 파트너 목록·상세에는 계속 보여야 하므로(사유를 알 길이 그것뿐이다) showsReviewBadge 는
// 반려 딜에도 true 를 돌려주고, 배지는 영업단계 대신 '반려됨' 을 보여준다.

export const REVIEW_STATUSES = ["pending", "approved", "rejected"];

export const REVIEW_PENDING = "pending";
export const REVIEW_APPROVED = "approved";
export const REVIEW_REJECTED = "rejected";

// **심사 상태가 아니다** — 관리자 [딜 심사 > 처리 완료] 탭이 승인분과 반려분을 한 목록으로
// 받아오기 위한 목록 조회 전용 묶음값(GET /admin/deal-reviews?status=done). 백
// `constants/dealReview.js` 의 DEAL_REVIEW_DONE 와 동기. 딜의 reviewStatus 비교에 쓰지 말 것.
export const REVIEW_LIST_DONE = "done";

// 심사 미완료 = 활성 딜이 아니다. 영업단계 표시·도입 전환·KPI 집계에서 제외하는 기준.
// reviewStatus 가 없는 응답(구 캐시 등)은 승인으로 본다 — 기존 딜이 전부 승인이라 그게 안전한 기본값.
export const isReviewPending = (deal) => !!deal && deal.reviewStatus === REVIEW_PENDING;
export const isReviewRejected = (deal) => !!deal && deal.reviewStatus === REVIEW_REJECTED;
export const isReviewApproved = (deal) =>
  !!deal && (!deal.reviewStatus || deal.reviewStatus === REVIEW_APPROVED);

// 심사 배지를 영업단계 배지 대신 보여줄지 — 승인 전(심사 중·반려)이면 true.
export const showsReviewBadge = (deal) => isReviewPending(deal) || isReviewRejected(deal);

// 화면이 그 딜의 상태로 **실제 보여주는 값** — 승인 전이면 심사 상태, 승인됐으면 영업단계.
// DealStageBadge 와 대시보드 상태 필터가 **같은 함수를 쓴다.** 둘이 갈라지면 파트너가
// 목록에서 본 '반려됨' 을 필터로 고를 수 없는 불일치가 생긴다(실제로 그랬다).
//
// 두 축(review_status · status)을 섞는 것이 아니라 **배지가 이미 쓰는 규칙으로 투영**하는
// 것이다. 그래서 한 딜의 유효 상태는 정확히 하나이고(심사중 / 반려됨 / 영업단계 7개 중 하나),
// 필터 탭이 배타적으로 동작한다. 새 심사 상태가 생기면 이 함수만 고치면 둘 다 따라온다.
export const effectiveStatus = (deal) =>
  showsReviewBadge(deal) ? deal.reviewStatus : deal && deal.status;

// 상태 필터 탭 순서 — 딜의 생애를 따라간다: 심사 대기 → (승인) 영업단계 → 반려(종료).
// 관리자 대시보드 탭을 같은 원칙으로 정렬한 선례와 맞춘다. 호출부는 앞에 '전체' 를 붙인다.
export const statusFilterOrder = (salesStages) => [REVIEW_PENDING, ...salesStages, REVIEW_REJECTED];

// Badge tone 은 심사 상태값을 그대로 쓴다 — ui/Badge 의 TONE 에 pending(amber)·approved(emerald)·
// rejected(rose) 가 이미 있고 가입 신청 상태와 같은 의미 체계다. 별도 매핑을 두지 않는다.
